export async function getImageDimensions(
  file: File,
): Promise<{ readonly height: number; readonly width: number }> {
  const url = URL.createObjectURL(file);

  try {
    const image = new Image();

    await new Promise<void>((resolve, reject) => {
      image.addEventListener("load", () => {
        resolve();
      });

      image.addEventListener("error", () => {
        reject(new Error("Failed to load image."));
      });

      image.src = url;
    });

    return { height: image.naturalHeight, width: image.naturalWidth };
  } finally {
    URL.revokeObjectURL(url);
  }
}
